// css =>
import "../../BaseStructure.css";
import Styled from "./WelcomePageFromeLogIn.module.css";

// react =>
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// componenets =>
import Header from "../../Components/header/header.comp";

function WelcomePageFromLogIn() {

    const navigate = useNavigate();

    useEffect(() => {
        document.title = "خوش آمدید";

        const timer = setTimeout(() => {
            navigate("/");
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <Header />

            <br /><br /><br /><br />

            <div className="row" id={ Styled.WelcomePageSectionFrame }>
                <div className="col-12">
                    <h1>ورود با موفقیت انجام شد !</h1>
                    <h3>به فروشگاه تخصصی محصولات چرمی ویدوک خوش آمدید.</h3>
                </div>

                <div className="col-12">
                    <p>در حال انتقال به سایت...</p>
                </div>
            </div>
        </>
    )
}

export default WelcomePageFromLogIn;
